import { cardItems } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Professional%20Chinese%20period%20drama%20set%20with%20elaborate%20costumes%20and%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20artistic%20editorial%20photography%20style%2C%20elegant%20composition%2C%20soft%20atmospheric%20glow&width=800&height=600&seq=card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20urban%20couple%20in%20warm%20coffee%20shop%20setting%2C%20soft%20natural%20light%20streaming%20through%20windows%2C%20intimate%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20warm%20neutral%20color%20palette&width=800&height=600&seq=card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20room%20with%20evidence%20board%20and%20investigation%20materials%2C%20suspense%20thriller%20atmosphere%2C%20dramatic%20lighting%2C%20film%20noir%20style%2C%20warm%20amber%20and%20deep%20shadow%20tones&width=800&height=600&seq=card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20scene%20with%20flowing%20fabric%20and%20dynamic%20movement%20against%20misty%20mountain%20backdrop%2C%20cinematic%20widescreen%2C%20warm%20golden%20hour%20lighting%2C%20artistic%20composition&width=800&height=600&seq=card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Nostalgic%20school%20rooftop%20scene%20with%20group%20of%20young%20friends%20at%20sunset%2C%20warm%20golden%20light%2C%20youthful%20hopeful%20atmosphere%2C%20cinematic%20composition%2C%20soft%20dreamy%20quality&width=800&height=600&seq=card-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Futuristic%20laboratory%20with%20holographic%20displays%20and%20warm%20ambient%20lighting%2C%20sci%20fi%20atmosphere%2C%20cinematic%20composition%2C%20sophisticated%20color%20grading%2C%20mysterious%20and%20intriguing%20mood&width=800&height=600&seq=card-06&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              编辑力荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              编辑部深度解读，带你发现更多好剧与行业洞察
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {cardItems.map((item, index) => (
              <div
                key={item.title}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                  <img
                    src={cardImages[index]}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.summary}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-sm text-primary-600 font-medium group-hover:gap-2 transition-all cursor-pointer">
                    阅读全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}